<!-- Geometría/estados: clases sinay-action-* del theme (styles/actions.css).
     El color por acción se inyecta vía --sinay-action-color; sin color,
     aplica el default del theme (#1890ff). -->
<div class="sinay-action-group">
  @for (btn of actions(); track btn.action) {
    @if (isVisible(btn)) {
      <button
        class="sinay-action-btn"
        [style.--sinay-action-color]="btn.color ?? null"
        [attr.aria-label]="btn.tooltip ?? btn.action"
        [disabled]="isDisabled(btn)"
        nz-tooltip
        [nzTooltipTitle]="btn.tooltip"
        (click)="emit(btn, $event)"
        type="button"
      >
        <span nz-icon [nzType]="btn.icon" nzTheme="outline"></span>
      </button>
    }
  }
</div>
